import { useEffect, useState } from 'react';
import Fuse from 'fuse.js';
import { GO_TO_SETUP_APP } from '../routes/paths';
import fetchAccessGroups from '../api/fetchAccessGroups';
import { getMyGroupAccessId, setMyGroupAccessId } from '../store/localstorage';
import { Input } from 'antd';
import { addAlpha, getColorForString } from './utils';
import { deleteDb } from '../store/idbHandler';
import AntButton from '../components/prescriptionPad/rightPanel/workspace/padV2/AntButton';

const ChangeGroup: React.FC = () => {
    const [groups, setGroups] = useState<{ id: string; name: string; doctors: string[] }[]>();
    const [fetchState, setFetchState] = useState<'loading' | 'success' | 'error'>('loading');
    const [searchInput, setSearchInput] = useState<string | undefined>();

    const fuse = new Fuse(groups || [], {
        keys: ['name'],
        includeScore: true,
        threshold: 0.4,
        ignoreLocation: true,
    });

    useEffect(() => {
        setFetchState('loading');
        fetchAccessGroups()
            .then((response) => {
                if (response.groups) {
                    setFetchState('success');
                    setGroups(response.groups || []);
                    fuse.setCollection(response.groups || []);
                }
                setFetchState('error');
            })
            .catch((e) => {
                console.log(e), setFetchState('error');
            });
    }, []);

    const onGroupSelect = async (groupId?: string) => {
        setFetchState('loading');
        setMyGroupAccessId(groupId);
        await deleteDb();
        window.location.replace(GO_TO_SETUP_APP);
    };

    if (fetchState === 'loading') {
        return (
            <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
                <div className="pulse">
                    <svg width="16px" height="12px">
                        <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    </svg>
                </div>
            </div>
        );
    }

    let renderList = [
        groups?.find((g) => g.id === getMyGroupAccessId()),
        ...(groups || []).filter((g) => g.id !== getMyGroupAccessId()),
    ].filter(Boolean) as { id: string; name: string; doctors: string[] }[];

    if (searchInput) {
        renderList = fuse.search(searchInput).map((result) => result.item);
    }

    return (
        <div className="flex flex-col w-screen h-full font-lato bg-neutral-9 overflow-hidden">
            <div className="modal-overlay"></div>
            <div className="flex w-30p z-10 modal-content h-4/5 rounded-8 overflow-hidden">
                <div className="w-full">
                    <div className="bg-background-action-states-white rounded-32 space-y-16 md:space-y-24 h-full flex flex-col flex-auto flex-1">
                        <span>
                            <div className="flex items-center justify-between p-16 bg-neutral-9 rounded-t-8 w-full space-between">
                                <p className="font-700 text-neutral-1 text-18">Switch Group</p>
                                <AntButton
                                    type="secondary"
                                    onClick={() => onGroupSelect(undefined)}
                                >
                                    Default View
                                </AntButton>
                            </div>
                            <div className="p-8 w-full">
                                <Input
                                    placeholder="Search"
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    className="border-b border-neutral-7"
                                    value={searchInput}
                                    allowClear
                                    autoFocus
                                />
                            </div>
                            <div className="w-full border-b border-neutral-7"></div>
                        </span>

                        <div className="flex-1 overflow-auto pb-24 h-full tbody-fade-bg">
                            {renderList?.map((d) => (
                                <div>
                                    <div
                                        key={d.id}
                                        onClick={() => onGroupSelect(d.id)}
                                        className={`p-8 cursor-pointer flex flex-row space-x-12 items-center ${
                                            getMyGroupAccessId() === d.id
                                                ? 'bg-darwin-primary-100'
                                                : ''
                                        }`}
                                    >
                                        <div className="overflow-hidden h-40 w-40 rounded-8 rounded-12 ">
                                            <div
                                                className="flex items-center justify-center w-40 h-40 leading-6 text-20 font-700 rounded-64"
                                                style={{
                                                    color: getColorForString(d.name[0] + 'random'),
                                                    backgroundColor: addAlpha(
                                                        getColorForString(d.name[0]),
                                                        0.1,
                                                    ),
                                                }}
                                            >
                                                {d.name[0].toUpperCase()}
                                            </div>
                                        </div>
                                        <div className="flex flex-col flex-1">
                                            <div className="text-neutral-black text-16 capitalize">
                                                {d.name}
                                            </div>
                                            <div className="text-neutral-4 text-12">
                                                {d.doctors.length} doctor(s)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeGroup;
